import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../context/Context";
import Layout from "../layouts/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "./SettingsPage.css";
import BackupsList from "../components/BackupsList";
import { BackupList } from "../api/api";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const BackupManagementPage = () => {
  const { page, setPage, settingsPage, authUser, setIsLoading } =
    useContext(Context);
  const [backupsList, setBackupsList] = useState();

  useEffect(() => {
    setPage({
      name: "مدیریت پشتیبان",
      slug: "backup-management",
    });

    setIsLoading(true);
    BackupList()
      .then(({ data }) => {
        setBackupsList(data.backups);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });

    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>مدیریت پشتیبان</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
            <div
              className="card h-100"
              style={{ backgroundColor: "#fff0", boxShadow: "none" }}
            >
              <div className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2">
                <h5>مدیریت پشتیبان</h5>
              </div>
              <div className="card-body scrollbar mt-4">
                {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
                <BackupsList
                  backupsList={backupsList}
                  setBackupsList={setBackupsList}
                />
                {/* </SimpleBar> */}
              </div>
            </div>
          </div>
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default BackupManagementPage;
